import { axiosInstance } from '../common/api';

/**
 * Create a new escalation
 */
export const createEscalation = (data) => {
  const url = `/escalation`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

/**
 * Get all escalations (with filters and pagination)
 */
export const getAllEscalations = (filters = {}, pagination = {}) => {
  const params = new URLSearchParams();

  if (filters.status) params.append('status', filters.status);
  if (filters.severity) params.append('severity', filters.severity);
  if (filters.escalatedTo) params.append('escalatedTo', filters.escalatedTo);
  if (filters.companyId) params.append('companyId', filters.companyId);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.search) params.append('search', filters.search);

  // Add pagination parameters
  if (pagination.page) params.append('page', pagination.page);
  if (pagination.pageSize) params.append('pageSize', pagination.pageSize);

  const queryString = params.toString();
  const url = `/escalation${queryString ? `?${queryString}` : ''}`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

/**
 * Get a single escalation by ID
 */
export const getEscalationById = (id) => {
  const url = `/escalation/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};


/**
 * Update escalation
 */
export const updateEscalation = (id, data) => {
  const url = `/escalation/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

/**
 * Delete escalation
 */
export const deleteEscalation = (id) => {
  const url = `/escalation/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

/**
 * Get escalation analytics
 */
export const getEscalationAnalytics = (companyId = null, startDate = null, endDate = null, search = null, pagination = {}) => {
  const params = new URLSearchParams();
  if (companyId) params.append('companyId', companyId);
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (search) params.append('search', search);
  if (pagination.page) params.append('page', pagination.page);
  if (pagination.pageSize) params.append('pageSize', pagination.pageSize);
  const queryString = params.toString();
  const url = `/escalation/analytics${queryString ? `?${queryString}` : ''}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

